import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Components
import AgeVerification from "./components/AgeVerification";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";

// Pages
import Home from "./pages/Home";
import Products from "./pages/Products";
import Story from "./pages/Story";
import Recipes from "./pages/Recipes";
import WhereToBuy from "./pages/WhereToBuy";
import Contact from "./pages/Contact";

function App() {
  const [isAgeVerified, setIsAgeVerified] = useState(false);

  useEffect(() => {
    const verified = sessionStorage.getItem("ageVerified");
    if (verified === "true") {
      setIsAgeVerified(true);
    }
  }, [setIsAgeVerified]);

  const handleAgeVerification = (isOver21) => {
    if (isOver21) {
      sessionStorage.setItem("ageVerified", "true");
      setIsAgeVerified(true);
    } else {
      window.location.href = "https://www.google.com";
    }
  };

  if (!isAgeVerified) {
    return <AgeVerification onVerify={handleAgeVerification} />;
  }

  return (
    <div className="App min-h-screen bg-[#050505]">
      <BrowserRouter>
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/story" element={<Story />} />
            <Route path="/recipes" element={<Recipes />} />
            <Route path="/where-to-buy" element={<WhereToBuy />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
